"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkeletonLoader = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _breakpoints = require("../constants/breakpoints");
var _jsxRuntime = require("react/jsx-runtime");
const MenuItem = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gridTemplateColumns: `${theme.spacing(5)} 1fr`,
  gridTemplateRows: '1fr',
  gap: theme.spacing(0, 1),
  alignItems: 'center',
  width: '100%'
}));
const MenuText = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  margin: theme.spacing(2, 2, 2, 6),
  height: '33px'
}));
const MenuIcon = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  margin: theme.spacing(2, 2, 2, 3),
  height: theme.spacing(6),
  width: theme.spacing(6)
}));
const Logout = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'absolute',
  zIndex: 999,
  paddingBottom: theme.spacing(3),
  background: '#f0f3f0',
  display: 'grid',
  gridTemplateColumns: `${theme.spacing(5)} 1fr`,
  gridTemplateRows: '1fr',
  alignItems: 'center',
  width: '100%',
  bottom: 0
}));
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'block',
  position: 'relative',
  top: 0,
  right: 0,
  left: 0,
  boxSizing: 'border-box',
  width: '100%',
  minWidth: theme.spacing(56),
  height: '100vh',
  maxHeight: `calc(100vh - ${theme.spacing(10)})`,
  overflow: 'hidden',
  backfaceVisibility: 'hidden',
  background: theme.palette.common.white,
  // eslint-disable-next-line @typescript-eslint/naming-convention -- this is css variable naming
  '--scrollbar-minlength': theme.spacing(2),
  // eslint-disable-next-line @typescript-eslint/naming-convention -- this is css variable naming
  '--scrollbar-ff-width': 'thin',
  marginTop: theme.spacing(3),
  [theme.breakpoints.up(_breakpoints.BREAKPOINT_HORIZONTAL_SIDEPANEL)]: {
    position: 'fixed',
    zIndex: 999,
    top: 'var(--top-nav-height)',
    right: 'unset',
    bottom: 0,
    left: 0,
    width: theme.spacing(56),
    maxWidth: theme.spacing(56),
    height: '100%',
    transition: 'unset',
    transitionProperty: 'unset',
    boxShadow: theme.shadows[2]
  }
}));
const SkeletonLoader = exports.SkeletonLoader = /*#__PURE__*/(0, _react.memo)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
  children: [Array.from({
    length: 6
  }, (_, key) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(MenuItem, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(MenuIcon, {
      animation: "wave",
      variant: "rectangular"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuText, {
      animation: "wave",
      variant: "text"
    })]
  }, `point-${key}`)), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Logout, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(MenuIcon, {
      animation: "wave",
      variant: "rectangular"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(MenuText, {
      animation: "wave",
      variant: "text"
    })]
  })]
}));